import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faFile);
library.add(faLinkedin);
library.add(faGithub);

Vue.component("font-awesome-icon", FontAwesomeIcon);
